import { render } from "./QueueWork.vue?vue&type=template&id=ef03069e&scoped=true"
import script from "./QueueWork.vue?vue&type=script&lang=js"
export * from "./QueueWork.vue?vue&type=script&lang=js"

import "./QueueWork.vue?vue&type=style&index=0&id=ef03069e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef03069e"]])

export default __exports__